import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContentSwitchItem } from './models/content-switch-item.model';
import { KhAnalyticsService } from 'app/shared/services/kh-analytics.service';

@Component({
  selector: 'kh-content-switch',
  styleUrls: ['./content-switch.component.less'],
  templateUrl: './content-switch.component.html',
  standalone: false
})
export class ContentSwitchComponent implements OnChanges, OnInit {
  private readonly khAnalyticsService = inject(KhAnalyticsService);

  public activeId = '';
  @Input() public options: ContentSwitchItem[] = [];
  @Input() public initialTrigger = false;
  @Input() public active = '';
  @Input() public trackingEvents: any = {};

  @Output() public optionSelected = new EventEmitter<string>();

  public ngOnInit(): void {
    if (this.options.length) {
      if (this.active) {
        this.activeId = this.active;
      }
      else {
        this.activeId = this.options[0].id;
      }

      if (this.initialTrigger) {
        this.selectOption(this.activeId);
      }
    }
  }

  public clickOption(optionId: string) {
    if (this.trackingEvents && this.trackingEvents[optionId]) {
      this.khAnalyticsService.trackEvent(this.trackingEvents[optionId]);
    }
    this.selectOption(optionId);
  }

  public selectOption(optionId: string) {
    this.activeId = optionId;
    this.optionSelected.emit(this.activeId);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.active) {
      this.selectOption(this.active);
    }
  }

  public isOptionActive(option: ContentSwitchItem): boolean {
    return this.activeId === option.id;
  }

  public getOptionPanelId(option: ContentSwitchItem): string | null {
    return option.panelId || null;
  }
}
